import { DotLottie } from 'https://cdn.jsdelivr.net/npm/@lottiefiles/dotlottie-web@0.76.0/+esm';
import { Component } from '@theme/component';

const { scroll } = window.Motion;

class LottieScrollAnimation extends Component {
  requiredRefs = ['container', 'canvas']

  #animation = null; 
  #dotLottie = null;

  connectedCallback() {
    super.connectedCallback();

    this.initLottie();
    this.initScroll();
  }

  initLottie() {
    if (! this.dataset.src) {
      return;
    }

    this.#dotLottie = new DotLottie({
      autoplay: false,
      loop: false,
      canvas: this.refs.canvas,
      src: this.dataset.src,
      layout: {
        fit: 'cover',
        align: [0.5, 0.5]
      },
      renderConfig: {
        autoResize: true,
      },
    });
  }

  initScroll() {
    if (!this.#dotLottie) {
      return;
    }

    this.#animation = scroll((progress) => {
      const newFrame = Math.round(progress * this.#dotLottie.totalFrames);
      this.#dotLottie.setFrame(newFrame);
    }, {
      target: this,
    });
  }
}

if (!customElements.get('lottie-scroll-animation')) {
  customElements.define('lottie-scroll-animation', LottieScrollAnimation);
}